module.exports = __webpack_public_path__ + "img/gr.6350cbad.svg";